import React from 'react';
import {motion} from 'framer-motion';

const SolutionSection = () => {
  return (
    <section className="py-20 px-4 bg-gradient-to-br from-[#F5F5F5] to-[#E8E8E8]">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Book Mockup */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="relative transform rotate-3 hover:rotate-0 transition-transform duration-500">
              <img 
                src="https://static.wixstatic.com/media/4fbfa6_d8ac54a7a1dd459abcc3031a27d29bdf~mv2.png" 
                alt="แค่หายใจก็เหนื่อย? ลองใช้ชีวิต 24 ซีซั่นดู - หนังสือ" 
                className="w-full max-w-md mx-auto rounded-lg shadow-2xl" 
              />
              <div className="absolute inset-0 bg-gradient-to-br from-[#556B2F]/10 to-[#6082B6]/10 rounded-lg"></div>
            </div>

            {/* Floating E-book */}
            <motion.div
              animate={{ y: [-10, 10, -10] }}
              transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
              className="absolute -top-8 -right-8 transform rotate-12"
            >
              <div className="bg-white p-4 rounded-lg shadow-xl border-2 border-[#E07A5F]">
                <div className="w-20 h-24 bg-gradient-to-br from-[#556B2F] to-[#6082B6] rounded flex items-center justify-center">
                  <img 
                    src="https://static.wixstatic.com/media/4fbfa6_d8ac54a7a1dd459abcc3031a27d29bdf~mv2.png" 
                    alt="E-Book Version" 
                    className="w-16 h-20 object-cover rounded shadow-sm"
                  />
                </div>
                <p className="text-xs mt-2 text-center font-semibold">E-Book</p>
              </div>
            </motion.div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-5xl font-bold text-[#333333] mb-6" style={{ fontFamily: 'Kanit, sans-serif' }}>
              จะดีแค่ไหน...ถ้ามี <span className="text-[#556B2F]">"Life Manual"</span> ที่ช่วยจูนชีวิตคุณใหม่?
            </h2>

            <div className="space-y-6 text-lg" style={{ fontFamily: 'Sarabun, serif' }}>
              <p className="text-[#666666] leading-relaxed">
                ขอแนะนำ <strong className="text-[#E07A5F]">"แค่หายใจก็เหนื่อย? ลองใช้ชีวิต 24 ซีซั่นดู"</strong> หนังสือที่จะเปลี่ยนภูมิปัญญาโบราณอายุกว่า 3,000 ปีให้กลายเป็น Life Hack ที่ทรงพลังที่สุดสำหรับคนยุคใหม่
              </p>
              <p className="text-[#666666] leading-relaxed">
                นี่ไม่ใช่หนังสือที่จะบอกให้คุณทิ้งชีวิตเมืองแล้วกลับเข้าป่า แต่คือคู่มือที่จะสอนให้คุณใช้ <strong className="text-[#556B2F]">"จังหวะของธรรมชาติ"</strong> มาเป็นเข็มทิศนำทางชีวิตที่วุ่นวาย เพื่อให้คุณประสบความสำเร็จได้อย่าง <strong className="text-[#6082B6]">"ยั่งยืน"</strong> และมีความสุขกว่าเดิม
              </p>
            </div>

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="mt-8 bg-[#E07A5F] hover:bg-[#d16847] text-white font-bold py-3 px-6 rounded-full transition-all duration-300"
              onClick={() => document.getElementById('offer-section').scrollIntoView({ behavior: 'smooth' })}
            >
              เรียนรู้เพิ่มเติม
            </motion.button>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;